<div class="mt--100 block payment-plans">
  <h3>Recurring Payments</h3>

  <ng-container *ngIf="(hasError$ | async) === false; else errorState">
    <div class="mt--125">
      <div class="data-table__cont">
        <table mat-table matSort matSortActive="timeFrame"
               [dataSource]="paymentPlanService.dataSourcePaymentPlans"
               matSortDirection="asc" class="data-table__tbl" data-cy="recurring-payments-table"
        >

          <!--Name-->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Name
            </th>
            <td mat-cell *matCellDef="let paymentPlanUi" data-cy="recurring-payment-name">
              {{paymentPlanUi.paymentPlan.name}}
            </td>
          </ng-container>

          <!--Client (account)-->
          <ng-container matColumnDef="client">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Account
            </th>
            <td mat-cell *matCellDef="let paymentPlanUi" data-cy="recurring-payment-account">
              {{paymentPlanUi.client.name}}
            </td>
          </ng-container>

          <!--Amount-->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Amount
            </th>
            <td mat-cell *matCellDef="let paymentPlanUi" data-cy="recurring-payment-amount">
              {{
                paymentPlanUi.paymentPlan.amount | addPaymentFees
                  : paymentPlanUi.paymentPlan.paymentMethod
                    : true
                    : paymentPlanUi.paymentPlan.usState
                    : paymentPlanUi.paymentPlan.country
                    : paymentPlanUi.client.id
                    : clientToBusinessEntityMap()[paymentPlanUi.client.id]
                  | currency
              }}
            </td>
          </ng-container>

          <!--Method-->
          <ng-container matColumnDef="method">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Method
            </th>
            <td mat-cell *matCellDef="let paymentPlanUi" class="tt--capitalize" data-cy="recurring-payment-method">
              <div *ngIf="savedPaymentMethodsLoaded && isPaymentMethodFromOtherUser(paymentPlanUi.paymentPlan.paymentMethodId); then thenBlock else elseBlock"></div>

              <!--Renders when the payment method is not owned by the current user-->
              <ng-template #thenBlock>

                <!--Renders if payment method is ACH-->
                <span *ngIf="isDirectDebit(paymentPlanUi.paymentPlan.paymentMethod); else card">
              <img src="assets/payment-methods/union.svg" width="20" height="20" alt="" class="data-table__payment-icon">
                  {{ paymentPlanUi.paymentPlan.paymentMethod | uppercase }} Bank Transfer ••••{{paymentPlanUi.paymentPlan.last4}}
                  <button (click)="launchPaymentMethodIsNotFromUserInfoModal()">
                  <div class="badge--primary">
                    <svg width="12" height="20" viewBox="0 0 16 16" fill="currentColor" class="inline-icon">
                      <path
                        d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S11.3,14,8,14z"></path>
                      <rect x="7" y="7" width="2" height="5"></rect>
                      <circle cx="8" cy="5" r="1"></circle>
                    </svg>
                  </div>
                </button>
              </span>

                <!--Renders if payment method is CREDIT or DEBIT-->
                <ng-template #card>
                  <img
                    src="assets/payment-methods/{{paymentPlanUi.paymentPlan.cardType}}.svg"
                    width="20" height="20" alt="" class="data-table__payment-icon">
                  {{paymentPlanUi.paymentPlan.cardType}}
                  ••••{{paymentPlanUi.paymentPlan.last4}}
                  <button (click)="launchPaymentMethodIsNotFromUserInfoModal()">
                    <div class="badge--primary">
                      <svg width="12" height="20" viewBox="0 0 16 16" fill="currentColor" class="inline-icon">
                        <path
                          d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S11.3,14,8,14z"></path>
                        <rect x="7" y="7" width="2" height="5"></rect>
                        <circle cx="8" cy="5" r="1"></circle>
                      </svg>
                    </div>
                  </button>
                </ng-template>
              </ng-template>

              <!--Renders when the payment method is owned by the current user-->
              <ng-template #elseBlock>

                <!--Renders if payment method is ACH-->
                <span *ngIf="isDirectDebit(paymentPlanUi.paymentPlan.paymentMethod); else card">
              <img
                src="assets/payment-methods/union.svg"
                width="20" height="20" alt="" class="data-table__payment-icon">
                  {{ paymentPlanUi.paymentPlan.paymentMethod | uppercase }} Bank Transfer ••••{{ paymentPlanUi.paymentPlan.last4 }}
              </span>

                <!--Renders if payment method is CREDIT or DEBIT-->
                <ng-template #card>
                  <img
                    src="assets/payment-methods/{{paymentPlanUi.paymentPlan.cardType}}.svg"
                    width="20" height="20" alt="" class="data-table__payment-icon">
                  {{paymentPlanUi.paymentPlan.cardType}}
                  ••••{{paymentPlanUi.paymentPlan.last4}}
                </ng-template>
              </ng-template>
            </td>
          </ng-container>

          <!--Time Frame (sorts by start date)-->
          <ng-container matColumnDef="timeFrame">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Time Frame
            </th>
            <td mat-cell *matCellDef="let paymentPlanUi" data-cy="recurring-payment-time-frame">
              <div>
                <div>
                  {{paymentPlanUi.paymentPlan.startDate | date: 'MM/dd/yy' }} - {{paymentPlanUi.paymentPlan.endDate | date: 'MM/dd/yy' }}
                </div>
              </div>
            </td>
          </ng-container>

          <!--Menu Button-->
          <ng-container matColumnDef="actions" class="width--1">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let paymentPlanUi">
              <div class="deactivate-cell">
                <button type="button" class="button button--text" data-cy="edit-payment-plan" (click)="openNewPaymentPlanModal(true, paymentPlanUi)">
                  <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="button__icon">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                <button type="button" class="button button--text" data-cy="delete-payment-plan" (click)="deactivatePaymentPlan(paymentPlanUi)">
                  <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="button__icon">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="data-table__row"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsToDisplay" class="data-table__row"></tr>
        </table>
      </div>
    </div>
    <button type="button" data-cy="new-payment-plan" (click)="openNewPaymentPlanModal(false, null)" class="mt--125 text-button">+ New Recurring Payment</button>
  </ng-container>
</div>

<ng-template #errorState>
  <div class="mt--050">Sorry, Recurring Payments settings are currently unavailable. Please check back again soon.</div>
</ng-template>
